<template>
  <div class="buy-car-month-card-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('buyCarMonthCard.title')" :subtitle="$t('buyCarMonthCard.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <!-- 表单区 -->
      <el-form ref="form" :model="buyCarMonthCardInfo" label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('buyCarMonthCard.carNum')" prop="carNum"
              :rules="[{ required: true, message: $t('buyCarMonthCard.rules.carNumRequired'), trigger: 'blur' }]">
              <el-input v-model.trim="buyCarMonthCardInfo.carNum"
                :placeholder="$t('buyCarMonthCard.placeholders.carNum')" @blur="_queryOwnerCar" clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('buyCarMonthCard.card')" prop="cardId"
              :rules="[{ required: true, message: $t('buyCarMonthCard.rules.cardRequired'), trigger: 'change' }]">
              <el-select v-model="buyCarMonthCardInfo.cardId"
                :placeholder="$t('buyCarMonthCard.placeholders.card')" @change="_changeCard" class="w-full">
                <el-option v-for="(item, index) in buyCarMonthCardInfo.cards" :key="index"
                  :label="`${item.cardName}(${item.cardMonth}${$t('common.month')})`" :value="item.cardId">
                </el-option>
              </el-select>
              <div class="ds-tip-text">{{ $t('buyCarMonthCard.tip') }}</div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('buyCarMonthCard.paymentMethod')" prop="primeRate"
              :rules="[{ required: true, message: $t('buyCarMonthCard.rules.paymentMethodRequired'), trigger: 'change' }]">
              <el-select v-model="buyCarMonthCardInfo.primeRate"
                :placeholder="$t('buyCarMonthCard.placeholders.paymentMethod')" class="w-full">
                <el-option v-for="(item, index) in filteredPrimeRates" :key="index" :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('buyCarMonthCard.receivableAmount')">
              <el-input v-model="buyCarMonthCardInfo.receivableAmount"
                :placeholder="$t('buyCarMonthCard.placeholders.receivableAmount')" disabled>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('buyCarMonthCard.receivedAmount')" prop="receivedAmount"
              :rules="[{ required: true, message: $t('buyCarMonthCard.rules.receivedAmountRequired'), trigger: 'blur' }]">
              <el-input v-model="buyCarMonthCardInfo.receivedAmount" type="number"
                :placeholder="$t('buyCarMonthCard.placeholders.receivedAmount')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('buyCarMonthCard.remark')">
              <el-input v-model="buyCarMonthCardInfo.remark" type="textarea" :rows="3"
                :placeholder="$t('buyCarMonthCard.placeholders.remark')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表单操作区 -->
      <div class="ds-form-actions">
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveCarMonthOrderInfo">
          {{ $t('common.submit') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { buyCarMonthOrder, queryOwnerCars, queryCommunityCarMonthCards } from '@/api/fee/buyCarMonthCardApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'BuyCarMonthCardList',
  components: {
    DsPageHeader
  },
  data() {
    return {
      buyCarMonthCardInfo: {
        orderId: '',
        cardId: '',
        carNum: '',
        carId: '',
        primeRate: '',
        receivableAmount: '',
        receivedAmount: '',
        remark: '',
        cards: [],
        primeRates: [],
        areaNum: ''
      },
      communityId: ''
    }
  },
  computed: {
    filteredPrimeRates() {
      return this.buyCarMonthCardInfo.primeRates.filter(
        item => item.statusCd !== '5' && item.statusCd !== '6' && item.statusCd !== '8'
      )
    }
  },
  mounted() {
    this.communityId = getCommunityId()

    // 从路由参数获取车牌号
    if (this.$route.query.carNum) {
      this.buyCarMonthCardInfo.carNum = this.$route.query.carNum
      this._queryOwnerCar()
    }

    // 获取支付方式字典
    this.getPrimeRateDict()
  },
  methods: {
    async getPrimeRateDict() {
      try {
        const data = await getDict('pay_fee_detail', 'prime_rate')
        this.buyCarMonthCardInfo.primeRates = data
      } catch (error) {
        console.error('获取支付方式字典失败:', error)
        this.$message.error(this.$t('buyCarMonthCard.errors.getDictFailed'))
      }
    },

    async _queryOwnerCar() {
      if (!this.buyCarMonthCardInfo.carNum) return

      try {
        const params = {
          page: 1,
          row: 1,
          communityId: this.communityId,
          carNum: this.buyCarMonthCardInfo.carNum,
          carTypeCd: '1001'
        }

        const res = await queryOwnerCars(params)
        if (res.total < 1) {
          this.$message.warning(this.$t('buyCarMonthCard.warnings.carNotExist'))
          return
        }

        const carData = res.data[0]
        if (!carData.paId) {
          this.$message.warning(this.$t('buyCarMonthCard.warnings.carNoParkingSpace'))
          return
        }

        this.buyCarMonthCardInfo.carId = carData.carId
        this.buyCarMonthCardInfo.areaNum = carData.areaNum
        this._listBuyMonthCards()
      } catch (error) {
        console.error('查询车主车辆失败:', error)
        this.$message.error(this.$t('buyCarMonthCard.errors.queryCarFailed'))
      }
    },

    async _listBuyMonthCards() {
      if (!this.buyCarMonthCardInfo.areaNum) return

      try {
        const params = {
          communityId: this.communityId
        }

        const res = await queryCommunityCarMonthCards(params)
        this.buyCarMonthCardInfo.cards = res.cardConfigs || []
      } catch (error) {
        console.error('获取月卡列表失败:', error)
        this.$message.error(this.$t('buyCarMonthCard.errors.getCardsFailed'))
      }
    },

    _changeCard() {
      const cardId = this.buyCarMonthCardInfo.cardId
      const selectedCard = this.buyCarMonthCardInfo.cards.find(item => item.cardId === cardId)

      if (selectedCard) {
        this.buyCarMonthCardInfo.receivableAmount = selectedCard.cardPrice
        this.buyCarMonthCardInfo.receivedAmount = selectedCard.cardPrice
      }
    },

    async saveCarMonthOrderInfo() {
      try {
        // 表单验证
        await this.$refs.form.validate()

        const params = {
          ...this.buyCarMonthCardInfo,
          communityId: this.communityId
        }

        const res = await buyCarMonthOrder(params)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(res.msg || this.$t('buyCarMonthCard.errors.saveFailed'))
        }
      } catch (error) {
        if (error instanceof Error) {
          console.error('保存月卡订单失败:', error)
          this.$message.error(error.message)
        }
        // 验证失败不显示错误
      }
    },

    clearBuyCarMonthCardInfo() {
      this.$refs.form.resetFields()
      this.buyCarMonthCardInfo.cards = []
      this.buyCarMonthCardInfo.areaNum = ''
      this.getPrimeRateDict()
    },

    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.buy-car-month-card-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色表单面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
}

.ds-form {
  padding: var(--ds-spacing-lg) var(--ds-spacing-lg) 0;

  ::v-deep .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }

  ::v-deep .el-form-item__label {
    color: var(--ds-gray-700);
    font-weight: 500;
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  border-top: 1px solid var(--ds-gray-200);
}

/* 辅助文本 */
.ds-tip-text {
  font-size: var(--ds-font-size-xs);
  color: var(--ds-gray-500);
  margin-top: 5px;
  line-height: 1.6;
}
</style>
